//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
//  -- Actions ------------------------
import * as NotesActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create note --------------------

export const handleCreateBubbleNote = (data) => async(dispatch) => {
    await dispatch(NotesActions.createNote());

    try {
        const noteData = await apis.post('notesRDS', `/bubbleNoteCreate`, {
            body: { ...data }
        });
        await dispatch(NotesActions.createNoteSuccess(noteData));
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'creating bubble note',
                error,
                module: 'NOTES',
                operation: 'CREATE_BOOK_NOTE'
            });
         }
        await dispatch(NotesActions.createNoteFail(error));
    }
};

// List Notes by Book, class and userId

export const handleGetBubbleByBook = (data) => async(dispatch) => {
    try {
        const noteData = await apis.post('notesRDS', `/bubbleByBook`, {
            body: { ...data }
        });
        await dispatch(NotesActions.listNoteByBookSuccess(noteData));
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing bubble by book',
                error,
                module: 'NOTES',
                operation: 'LIST_BOOK_BOOK_BOOK'
            });
         }
         await dispatch(NotesActions.listNoteByBookFail(error));
    }
};

//  -- List class notes ---------------


export const handleListBubbleClassNotes = (classID) => async(dispatch) => {
    await dispatch(NotesActions.listClassNotes());

    try {
        const notesRDS = await apis.get('notesRDS', `/bubbleByClass/${classID}`);
        let notesDataArr=[]
        if(Array.isArray(notesRDS)&&notesRDS.length>0){
            notesDataArr=notesRDS
        }
        await dispatch(NotesActions.listClassNotesSuccess(notesDataArr));
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing bubble class notes',
                error,
                module: 'NOTES',
                operation: 'LIST_BOOK_CLASS_NOTE'
            });
         }
        await dispatch(NotesActions.listClassNotesFail(error));
    }
};

//  -- List user notes ----------------
export const handleListUserNotes = (userID,cb) => async(dispatch) => {
    return;
    //sifted to bubble notes
    // await dispatch(NotesActions.listUserNotes());

    // try {
    //      let notes = [];
    //     const notesRDS = await apis.get('notesRDS', `/notesByUser/${userID}`);
    //     if(Array.isArray(notesRDS)&&notesRDS.length>0){
    //         notes=notesRDS
    //     }
    //     if(cb)  return notes;
    //     await dispatch(NotesActions.listUserNotesSuccess(notes));
    // } catch (error) {
    //     if(error&&error.message!="Network Error"){
    //         logToSentry({
            //     message: 'listing user notes',
            //     error,
            //     module: 'NOTES',
            //     operation: 'LIST_USER_NOTE'
            // });
    //      }
    //     await dispatch(NotesActions.listUserNotesFail(error));
    // }
};

export const handleListBubbleUserNotes = (userID,cb) => async(dispatch) => {
    await dispatch(NotesActions.listUserNotes());

    try {
         let notes = [];
        const notesRDS = await apis.get('notesRDS', `/bubbleByUser/${userID}`);
        if(Array.isArray(notesRDS)&&notesRDS.length>0){
            notes=notesRDS
        }
        if(cb)  return notes;
        await dispatch(NotesActions.listUserNotesSuccess(notes));
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing bubble user notes',
                error,
                module: 'NOTES',
                operation: 'LIST_BOOK_USER_NOTE'
            });
         }
        await dispatch(NotesActions.listUserNotesFail(error));
    }
};


//  -- Update class quiz --------------
export const handleUpdateNote = (noteID, data, color) => async(dispatch) => {
    await dispatch(NotesActions.updateNote());

    try {
         await apis.put('notesRDS', `/notes/${noteID}`, {
            body: { 
                "content": data,
                "color": color 
            }
        });
        await dispatch(NotesActions.updateNoteSuccess({ id: noteID, ...data }));
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'updating note',
                error,
                module: 'NOTES',
                operation: 'UPDATE_NOTE'
            });
         }
        await dispatch(NotesActions.updateNoteFail(error));
    }
};

export const handleBubbleUpdateNote = (noteID, data, color) => async(dispatch) => {
    await dispatch(NotesActions.updateNote());

    try {
        const updatedRow = await apis.put('notesRDS', `/bubbleUpdate/${noteID}`, {
            body: {
                content: data,
                color: color,
            },
        });
        const payload =
            updatedRow &&
            typeof updatedRow === 'object' &&
            !updatedRow.error &&
            updatedRow.id
                ? updatedRow
                : { id: noteID, ...data };
        await dispatch(NotesActions.updateNoteSuccess(payload));
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'updating bubble note',
                error,
                module: 'NOTES',
                operation: 'UPDATE_BOOK_NOTE'
            });
         }
        await dispatch(NotesActions.updateNoteFail(error));
    }
};

export const handleUpdateShareList  = (note_id, share_id, current_user_id) => async (dispatch) => {
    try{
        const response = await apis.post('notesRDS', `/bubbleUpdateShareList`, {
            body: {
                note_id: note_id,
                share_id: share_id,
                user_id: current_user_id
            }
        });
        
        if(response && response.id){
            const updatedNote = {
                ...response,
                share_list: response.share_list || []
            };
            await dispatch(NotesActions.updateNoteSuccess(updatedNote));
        }
        return response;
    }catch(error){
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'updating bubble share list',
                error,
                module: 'NOTES',
                operation: 'UPDATE_BUBBLE_SHARE_LIST'
            });
         }
        throw error;
    }
}

export const handleGetShareByWithMeList  = (data) => async () => {
    try{
        const response = await apis.post('notesRDS', `/bubbleNotesSharedList`, {
            body: data
        });
        return response?.result?.bubbleNotes;
    }catch(error){
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'updating bubble share list',
                error,
                module: 'NOTES',
                operation: 'UPDATE_BUBBLE_SHARE_LIST'
            });
         }
    }
}